import { ControlType, FetchStatus } from "../../../../base/types";
import { ErrorMessage, Spinner } from "../../../../widgets";
import { PayTmProperties, usePayTmProperties } from "./PayTmProperties";

import { DraftPaytmButtonComponent } from "./DraftPaytmButtonComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../../base/models";
import { PayTmButton } from "./PayTmButton";
import { Registry } from "../../../../base/register";

export const PaytmButtonComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { status, properties, error } = usePayTmProperties(props);

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    if (!properties) return <></>

    return (
        <PayTmButton
            {...properties}
            className={className}>
            {children}
        </PayTmButton>
    )
}

Registry.addControl({
    id: "40a18a42-e320-4114-a1aa-6b265cbf5b9c",
    name: "Paytm Button",
    type: ControlType.PaytmButton,
    properties: PayTmProperties,
    component: PaytmButtonComponent,
    draftComponent: DraftPaytmButtonComponent
})
